import React from 'react';
const stats = [{
  number: '+200',
  label: 'Familias'
}, {
  number: '2',
  label: 'Tomos completos'
}, {
  number: '3',
  label: 'Bonos incluidos'
}, {
  number: '4.9/5',
  label: 'Valoración'
}];
export function StatsBar() {
  return <div className="bg-white border-b border-[#ebebeb] py-6 px-5" data-id="element-166">
      <div className="max-w-[860px] mx-auto flex flex-wrap justify-center gap-x-12 gap-y-6" data-id="element-167">
        {stats.map(s => <div key={s.label} className="text-center" data-id="element-168">
            <span className="block text-[1.8rem] font-bold text-navy-light leading-none" data-id="element-169">
              {s.number}
            </span>
            <span className="text-[0.78rem] text-[#888] uppercase tracking-[0.08em] mt-1 inline-block" data-id="element-170">
              {s.label}
            </span>
          </div>)}
      </div>
    </div>;
}